import AnalyticsInterface from './analyticsInterface'

/**
 * @class ProductPageAnalytics
 * @description Handles product page specific analytics
 */
class ProductAnalytics extends AnalyticsInterface {
  static EVENTS = {
    VIEW_ITEM: 'view_item'
  }

  static PRODUCT_SELECTOR = '[data-product-state]'

  static DEFAULT_CURRENCY = 'AUD'

  constructor(ga4) {
    super(ga4)
    this.initialize()
  }

  get product() {
    const productSelector = document.querySelector(ProductAnalytics.PRODUCT_SELECTOR)
    return productSelector ? JSON.parse(productSelector.textContent) : null
  }

  initialize() {
    const product = this.product
    if (!product) return
    this.viewItem(product)
  }

  viewItem(product) {
    if (!product) return

    const { currency = ProductAnalytics.DEFAULT_CURRENCY, price, sku, title, additionalData = {} } = product

    this.track(ProductAnalytics.EVENTS.VIEW_ITEM, {
      currency,
      value: price,
      items: [
        {
          item_id: sku,
          item_name: title,
          price,
          currency,
          ...additionalData
        }
      ]
    })
  }
}

export default ProductAnalytics
